import { render, staticRenderFns } from "./ListadoPedidosObsequios.vue?vue&type=template&id=9c1ffe86&scoped=true"
import script from "./ListadoPedidosObsequios.vue?vue&type=script&lang=js"
export * from "./ListadoPedidosObsequios.vue?vue&type=script&lang=js"
import style0 from "./ListadoPedidosObsequios.vue?vue&type=style&index=0&id=9c1ffe86&prod&scoped=true&lang=css"
import style1 from "./ListadoPedidosObsequios.vue?vue&type=style&index=1&id=9c1ffe86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1ffe86",
  null
  
)

export default component.exports